<div class="modal-wrapper">
  <h2 mat-dialog-title>{{data.title}}</h2>
  <mat-dialog-content>
    <ng-container *ngIf="data.message">
      <p *ngFor="let message of data.message">{{ message }}</p>
    </ng-container>
    <ng-container *ngIf="data.json">
      <textarea #jsonTextarea [value]="data.json | json"></textarea>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button (click)="close()">Close</button>
    <ng-container *ngIf="data.button">
      <button mat-stroked-button class="action-button" (click)="data.button.action()">
        {{data.button.label || 'Action'}}
        <mat-icon class="action-icon" *ngIf="data.button?.icon">
          {{data.button.icon}}
        </mat-icon>
      </button>
    </ng-container>
  </mat-dialog-actions>
</div>